// extracted by mini-css-extract-plugin
export default {"qrcode":"styles_qrcode__y4H5Y","description":"styles_description__MhVv+","icon":"styles_icon__NANnQ","iconBox":"styles_iconBox__dayDg"};